import { render, staticRenderFns } from "./PlayerBadges.vue?vue&type=template&id=470d5a08&scoped=true&"
import script from "./PlayerBadges.vue?vue&type=script&lang=js&"
export * from "./PlayerBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d5a08",
  null
  
)

export default component.exports